import { render, staticRenderFns } from "./UserHelpVideo.vue?vue&type=template&id=ccd33be2&scoped=true&"
import script from "./UserHelpVideo.vue?vue&type=script&lang=ts&"
export * from "./UserHelpVideo.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpVideo.vue?vue&type=style&index=0&id=ccd33be2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd33be2",
  null
  
)

export default component.exports